import React, { PropsWithChildren } from 'react';
import * as S from './ProfileMenuBtn.styles';
import { ProfileMenuIcon } from './ProfileMenuIcon';

interface ProfileMenuBtnProps {
  dataTestId?: string;
  isDropdownOpen: boolean;
  onClick: () => void;
}

export const ProfileMenuBtn = ({
  dataTestId,
  isDropdownOpen,
  onClick,
  children,
}: PropsWithChildren<ProfileMenuBtnProps>) => {
  return (
    <S.ProfileMenuBtnWrapper data-testid={dataTestId}>
      <S.ProfileMenuBtnBox onClick={onClick}>
        <ProfileMenuIcon />
        <S.ProfileMenuAngleIcon
          className="caret-icon"
          $isDropdownOpen={isDropdownOpen}
        />
      </S.ProfileMenuBtnBox>
      {children}
    </S.ProfileMenuBtnWrapper>
  );
};
